import React from "react";
import CurrencyFormat from "react-currency-format";
import { Radio } from "@rmwc/radio";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";

const TrussSection = ({ isCustomBuilding, filterData, params, const_var, standardTrussLabel, trussPrice, trussChange }) => {
	const building = const_var?.post_data?.building;

	const showPrice = const_var.hide_price_calculation != 1 && const_var.loginSession == false && building && trussPrice !== undefined && trussPrice !== 0;

	if (!isCustomBuilding || !filterData?.length) {
		return null;
	}

	return (
		<div className="form-group">
			<label className="control-label">Truss</label>

			{building && const_var.loginSession ? (
				<div className="price-box">
					<EditPriceItem jsonObj={trussPrice} jsonObjKey="truss_price" />
				</div>
			) : (
				<div className="price-box-type-2">{showPrice && <CurrencyFormat value={trussPrice} displayType="text" thousandSeparator prefix="$" />}</div>
			)}

			{filterData.map((item, index) => {
				const trussLabel =
					item?.label != null ? (params.m_s_n == 153 && item.is_default ? standardTrussLabel : item.label) : item.is_default ? standardTrussLabel : params.m_s_n == 153 ? "Ladder Truss" : "High Truss";

				const isChecked = item?.name?.replace(/[0-9]/g, "").includes(params.trussType);

				return (
					<div className="radio-group" key={index}>
						<Radio label={trussLabel} value={params.trussType} name={`truss${index}`} checked={isChecked} onChange={() => trussChange(item.name)} />
					</div>
				);
			})}
		</div>
	);
};

export default TrussSection;
